module.exports = __webpack_public_path__ + "img/small.6dfb4291.svg";